<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.manage_collections' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="action-container">
        <div>{{collections.length}} {{ (collections.length === 1 ? 'bikeshop.workshop.jobcard.quote.result' : 'bikeshop.workshop.jobcard.quote.results') | translate }}</div>
        <div><hub-button [icon]="'plus'" [size]="'md'" [style]="'borderless-secondary'" text="{{'bikeshop.workshop.jobcard.quote.create_a_collection' | translate}}"
            (buttonClick)="showCreateCollectionButton=true;"></hub-button></div>

    </div>

    <div class="collection-container">
        <div *ngFor="let collection of collections">
            <div>
                <hub-input [ngModel]="collection.collectionName + ' ('+ (collection.count || 0) +')'" [isDisabled]="true" ></hub-input>
            </div>
            <div (click)="deleteCollection(collection)"><daz-icon [name]="'trash'" [color]="'#EE3158'" size="'24px'"></daz-icon></div>
        </div>
        <div *ngIf="showCreateCollectionButton">
            <div>
                <hub-input [(ngModel)]="collectionName" [isDisabled]="false" [autofocus]="true" placeholder="{{'bikeshop.workshop.jobcard.quote.collection_examples' | translate}}" ></hub-input>
            </div>
            <div (click)="showCreateCollectionButton=false;collectionName=''"><daz-icon [name]="'trash'" [color]="'#EE3158'" size="'24px'"></daz-icon></div>
        </div>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.workshop.jobcard.quote.create_a_collection' | translate" [style]="'secondary'" [disabled]="!collectionName" *ngIf="showCreateCollectionButton"
            [size]="'xl'" (buttonClick)="createCollection()"></hub-button>
    </div>
    <div class="short-cut-container" *ngIf="showCreateCollectionButton">
        <span><daz-icon [name]="'enter'" [size]="'18px'" [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' | translate}}
    </div>
</div>
<p-confirmDialog key="delete-collection-dialog"></p-confirmDialog>